import { uniqueId } from 'lodash';

import { ApiHitData } from '@sbv-clients/data-access-api';
import { GridColDef } from '@sbv-clients/ui-shared';
import { nameOfFactory } from '@sbv-clients/util-misc';

export interface ApiMetricsRowType extends ApiHitData {}

export const apiMetricsRowKey = nameOfFactory<ApiMetricsRowType>();

export const getApiMetricsRowId = (row: ApiMetricsRowType) =>
  (row?.path || uniqueId()) + (row.facilityName || uniqueId());

export const apiMetricsColumns: GridColDef[] = [
  {
    flex: 2,
    headerName: 'Path',
    field: apiMetricsRowKey('path'),
  },
  {
    flex: 1,
    headerName: 'Method',
    field: apiMetricsRowKey('method'),
  },
  {
    flex: 1,
    headerName: 'Count',
    field: apiMetricsRowKey('count'),
  },
  {
    flex: 2,
    headerName: 'Facility Name',
    field: apiMetricsRowKey('facilityName'),
  },
];
